// extracted by mini-css-extract-plugin
export default {"l_DetailModalIcon_main":"DetailModalIcon_l_DetailModalIcon_main__iSZli","l_DetailModalIcon__icon_img":"DetailModalIcon_l_DetailModalIcon__icon_img__pz2Tc"};